import { FETCH_DASHBOARD } from "../actionTypes"

const DEFAULT_STATE = {}

export default (state = DEFAULT_STATE, action=null) => {
  if(action.type ===FETCH_DASHBOARD) {
    return {
      ...state,
      ...action.payload
    };
  } else {
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/store/reducers/dashboard.js